import { DataGrid } from '@tableau/data-grid-1-wrapper';
import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { SortableDataGrid } from '~commonInfra/components/dataGrid/SortableDataGrid';
import { imgUrl } from '~src/commonInfra/utils/ImgUrl';
import { IOrderClause } from '~src/spacesPlatform/serverApi/types/IOrderClause';

import { Messages } from '../../../codegen/Localize';
import { ISliceable } from '../../../httpClient/fetchers/ISliceable';

export interface ErrorDetailsDialogProps {
  readonly close?: (result: any) => void;
  /** Hides the arrow which displays at the top of the dialog by default */
  readonly hideArrow?: boolean;
  readonly sliceable: ISliceable<any>;
  readonly columns: DataGrid.Column[];
}

export const ERROR_DETAILS_DIALOG_WIDTH = 600;
const ErrorDetailsDialogStyle: React.CSSProperties = {
  width: ERROR_DETAILS_DIALOG_WIDTH.toString() + 'px',
  height: '300px',
  position: 'relative'
};

const getArrowUpStyle: () => React.CSSProperties = () => ({
  position: 'absolute',
  width: '30px',
  height: '16px',
  top: '-15px',
  left: '330px',
  background: imgUrl('modal_arrow_up.svg') + ' no-repeat center'
});

export class ErrorDetailsDialog extends React.Component<ErrorDetailsDialogProps> {

  public render(){
    return(<div className="tb-error-details-dialog">
            {!this.props.hideArrow && <div style={getArrowUpStyle()}/>}
            <div className="tb-sortable-data-grid" style={ErrorDetailsDialogStyle}>
              <SortableDataGrid
                columns={this.props.columns}
                getSliceable={(orderClause: IOrderClause[]) => {return this.props.sliceable;}}
              />
            </div>
            <div className="tb-dialog-actions">
                <ButtonWidget
                  buttonType={ButtonType.Outline}
                  testId="dismiss-error-details-dialog"
                  onClick={this.props.close}>
                  {Messages.dismiss()}
                </ButtonWidget>
                </div>
          </div>);
  }
}
